<ui-panel-header title="This is the title property. You'd think it would show up in the panel header but it doesn't. It's a standard html property used for tooltips."
  panelHeaderTitle="I am the panel header title"
>
  Content is not currently used for the panel header, this won't show up anywhere.
</ui-panel-header>
